import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import style from "./DataInfo.module.scss";
import { PortableText } from "@portabletext/react";
import { ProfilePage } from "../../../../pages/dashboard/ProfilePage";
export const DataInfo: React.FC<{
  page: ProfilePage;
}> = t0 => {
  const $ = _c(30);
  const {
    page
  } = t0;
  let t1;
  if ($[0] !== page.info_title) {
    t1 = <h5>{page.info_title}</h5>;
    $[0] = page.info_title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== page.tax_subtitle) {
    t2 = <strong>{page.tax_subtitle}</strong>;
    $[2] = page.tax_subtitle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== page.tax) {
    t3 = <PortableText value={page.tax} />;
    $[4] = page.tax;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = page.tax_link ?? "/";
  let t5;
  if ($[6] !== page.read_more_label || $[7] !== t4) {
    t5 = <Link href={t4} target="_blank">{page.read_more_label}→</Link>;
    $[6] = page.read_more_label;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t5) {
    t6 = <section className={style.tax}>{t2}{t3}{t5}</section>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== page.data_subtitle) {
    t7 = <strong>{page.data_subtitle}</strong>;
    $[13] = page.data_subtitle;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== page.data) {
    t8 = <PortableText value={page.data} />;
    $[15] = page.data;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const t9 = page.data_link ?? "/";
  let t10;
  if ($[17] !== page.read_more_label || $[18] !== t9) {
    t10 = <Link href={t9} target="_blank">{page.read_more_label}→</Link>;
    $[17] = page.read_more_label;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t7 || $[22] !== t8) {
    t11 = <section className={style.privacy}>{t7}{t8}{t10}</section>;
    $[20] = t10;
    $[21] = t7;
    $[22] = t8;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t6) {
    t12 = <div className={style.columns}>{t6}{t11}</div>;
    $[24] = t11;
    $[25] = t6;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t1 || $[28] !== t12) {
    t13 = <section className={style.columnswrapper}>{t1}{t12}</section>;
    $[27] = t1;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
};